import { PaymentPartnerType } from '../../codegen/vehicles';
import utaLogo from '../../assets/images/partners/uta-logo.webp';
import dkvLogo from '../../assets/images/partners/dkv-logo.webp';
import fuelingLogo from '../../assets/images/partners/fueling-placeholder.png';
import chargingLogo from '../../assets/images/partners/charging-placeholder.png';
import { PAYMENT_PARTNER_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';

type PaymentPartnerIconProps = {
  paymentPartner: PaymentPartnerType;
  [key: string]: string;
};

const paymentPartnerToIcon: { [key in PaymentPartnerType]: string } = {
  UTA_PAYMENT: utaLogo,
  MOCK_UTA_PAYMENT: utaLogo,
  MOCK_FUELING_PAYMENT: fuelingLogo,
  MAN_CHARGE_AND_GO_PAYMENT: chargingLogo,
  DKV_PAYMENT: dkvLogo,
};

export const PaymentPartnerIcon = ({
  paymentPartner,
  ...props
}: PaymentPartnerIconProps) => {
  return (
    <img
      alt={PAYMENT_PARTNER_TO_TRANSLATION_KEY[paymentPartner]}
      src={paymentPartnerToIcon[paymentPartner]}
      {...props}
    />
  );
};
